// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"right-outer__wrap--2W1WB"};